import React from 'react';
import styled from '@emotion/styled';
import PropTypes, { InferProps } from 'prop-types';
import PageCardContainer from '../PageCardContainer';
import Body1 from '../Typography/Body/Body1';
import breakpoints from '../Theme/breakpoints';
import { Breadcrumbs } from '../Breadcrumb';
import Headline1 from '../Typography/Heading/Headline1';

const BodyContainer = styled.div`
  margin: 1.5rem 1rem 0;

  @media (min-width: ${breakpoints.sm}px) {
    margin: 1.5rem auto;
    max-width: 65ch;
  }
`;

const BreadcrumbsWrapper = styled.div`
  display: flex;
  justify-content: start;
  flex-basis: 100%;
  padding-bottom: 2rem;
`;

const SubTitle = styled(Body1)`
  color: ${({ theme }) => theme.palette.primary.main};
  font-weight: 600;
  text-align: center;
  margin-bottom: .5rem;
`;

const Header = styled(Headline1)`
  text-align: center;
  margin-bottom: 1.5rem;
`;

const PageWrapper = styled.div`
  margin: 0 auto 32px;
  max-width: 970px;
  box-sizing: border-box;
  width: 100%;
  padding: 0 16px;
`;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const IntelligencePageLayoutPropertyTypes = {
  breadcrumbs: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.node,
    ]),
  ),
  content: PropTypes.node,
  description: PropTypes.node.isRequired,
  pageCards: PropTypes.arrayOf(
    PropTypes.node.isRequired,
  ),
  subTitle: PropTypes.string,
  title: PropTypes.string,
};

type IntelligencePageLayoutProperties = InferProps<
  typeof IntelligencePageLayoutPropertyTypes
>;

const IntelligencePageLayout = ({
  breadcrumbs,
  content,
  description,
  pageCards,
  subTitle,
  title,
}: IntelligencePageLayoutProperties) => {
  const pageCardsValue = pageCards ?? [];

  return (
    <PageWrapper>
      {breadcrumbs && (
      <BreadcrumbsWrapper>
        <Breadcrumbs crumbs={breadcrumbs} />
      </BreadcrumbsWrapper>
      )}
      {subTitle && (
      <SubTitle>{subTitle}</SubTitle>
      )}
      <Header tag="h1">{title}</Header>
      <BodyContainer>
        <Body1 tag="div">{description}</Body1>
      </BodyContainer>
      {content}
      {/* eslint-disable-next-line
      @typescript-eslint/no-unnecessary-condition */}
      {pageCardsValue && (
      <PageCardContainer pageCards={pageCardsValue} />
      )}
    </PageWrapper>
  );
};

export default IntelligencePageLayout;
